import {
  pageMoveAnkerFunc,
} from "./common/_pageLinkAnimation";
import {
  idxFunc,
  idxFunc2,
} from "./pages/_index";

import { animation } from "./pages/_animation";
import { slide } from "./pages/_animation";
import { scrollBar } from "./pages/_animation";
// import { scrollBar } from "./pages/_animation.js";
//* ----------------------------------------
//window実行
//--------------------------------------- */
////// ロード時
$(window).on('load', function () {
 idxFunc();
  idxFunc2();
  animation();
  slide();
  scrollBar();
  pageMoveAnkerFunc();

});


